import React, { useState } from "react";
import axios from "axios";
import constants from "../../../services/constants";
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';

const SubmitCVPopup = ({ onClose,jobId,tokenData }) => {

  const [formData, setFormData] = useState({
    
    cv: null,
  });
  const [loading, setLoading] = useState(false);

 


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value, // Handle file input
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const apiEndpoint = `${constants.API_BASE_URL}job/apply-job/${jobId}/cv`; // Replace with your API URL
    const uploadData = new FormData();
  
    uploadData.append("cv", formData.cv);

    try {
      const response = await axios.post(apiEndpoint, uploadData, {
        headers: { "Content-Type": "multipart/form-data",'Authorization': `Bearer ${tokenData}` },
      });

      onClose();
     
    } catch (error) {
      console.error("Error submitting CV:", error.response?.data || error.message);
      // alert("Failed to submit CV. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
       <div className={Style.popupOverlay} onClick={onClose}>
          <div className={Style.popupContent} onClick={(e) => e.stopPropagation()}>
            <h2>Submit Your CV</h2>
            <form onSubmit={handleSubmit}>
             
              <label className={Style.centerBtn}>
                <input type="file" name="cv" accept=".pdf" onChange={handleChange} className={Style.cvButton} required />
              </label>
              <div className={Style.centerBtn}>
                <button type="button" onClick={onClose} className={Button.brownBorderBtn} >Cancel</button>
                <button type="button" disabled={loading} className={Button.greenBtn}>{loading ? "Submitting..." : "Submit"}</button>
              </div>
            </form>
          </div>
        </div>
    );
};

export default SubmitCVPopup;
